import { weather } from 'Service/axios';
import { IDailyWeather } from 'Shared/Types/dailyWeather';

class Weather {
  async getWeeklyWeather(
    location: string,
  ): Promise<IDailyWeather[] | undefined> {
    const response = await weather.get(`${location}/next7days`, {
      params: {
        q: location,
      },
    });

    return response?.data?.days
      .slice(0, 7)
      .map(
        ({
          datetimeEpoch,
          temp,
          icon,
        }: {
          datetimeEpoch: number;
          temp: number;
          icon: string;
        }) => ({
          timestampInSec: datetimeEpoch,
          tempInF: temp,
          icon,
        }),
      );
  }
}

export default Weather;
